<div class="return-payment">
  <h2 class="headline">
    {{ "PAYMENT_PAGE.MODAL_RETURN.TITLE" | translate }}
  </h2>
  <div class="content">
    <div class="scroll-block">
      <div class="return-payment__line full">
        <h3 class="return-payment__line-headline">{{ "PAYMENT_PAGE.MODAL_RETURN.HEADLINE" | translate }}</h3>
        <div class="return-payment__line-buttons">
          <button
            *ngIf="info?.payment_type !== 'AFT'"
            [class.active]="!externalSystem && !cardMerchant"
            (click)="setRefundType('fromTransitAccount')"
            type="button"
            class="radio-btn">
            {{ "CHECKBOX.TRANSIT_RETURN" | translate }}
          </button>

          <button
            [class.active]="externalSystem"
            (click)="setRefundType('externalSystems')"
            type="button"
            class="radio-btn">
            {{ "CHECKBOX.RETURN_EXTERNAL_SYSTEM" | translate }}
          </button>

          <button
            *appHasAccess="['P2P_OPERATION']"
            [class.active]="cardMerchant"
            (click)="setRefundType('fromCard')"
            type="button"
            class="radio-btn">
            {{ "CHECKBOX.RETURN_CARD_MERCH" | translate }}
          </button>
        </div>
      </div>

      <div class="return-payment__line">
        <div class="return-payment__line-left">
          <div class="line full">
            <h3 class="headline">{{ "PAYMENT_PAGE.MODAL_RETURN.SUM" | translate }}:</h3>
            <p class="total-sum">
              {{ totalClaimSum }}
              <span class="total-sum__currency">
                {{ "PAYMENT_PAGE.MODAL_RETURN.CURRENCY" | translate }}
              </span>
            </p>
          </div>

          <div class="line">
            <div class="line__left">
              <h3 class="headline">{{ "PAYMENT_PAGE.MODAL_RETURN.IN_ID" | translate }}</h3>
              <p class="description">{{ id }}</p>
            </div>
            <div class="line__right">
              <h3 class="headline">{{ "PAYMENT_PAGE.MODAL_RETURN.FULL_NAME" | translate }}</h3>
              <p class="description">{{ name | fullName }}</p>
            </div>
          </div>

          <div class="line full">
            <div class="input-line" [class.required]="!comment.trim() && showValidation">
              <p class="input-line__name">
                {{ "PAYMENT_PAGE.MODAL_RETURN.INFO" | translate }} <span class="required">*</span>
              </p>
              <label>
                <textarea
                  [(ngModel)]="comment"
                  maxlength="500"
                  [class.error]="!comment.trim() && showValidation"
                  class="input-line__input textarea">
                </textarea>
              </label>
            </div>
          </div>

          <div class="line gap">
            <app-switch-table
              [item]="claimsFullCommission"
              (itemChange)="setClaims()">
            </app-switch-table>

            <span>{{ "CHECKBOX.WITHOUT_COMMISSION" | translate }}</span>

            <div class="info-btn">
              <img
                class="info-btn__icon"
                src="assets/img/Info.svg"
                alt />
              <span class="info-btn__tooltip">
                {{ "PAYMENT_PAGE.HINT" | translate }}
              </span>
            </div>
          </div>

          <div class="line full">
            <ng-container>
              <p class="file-description" [class.required]="files.length === 0 && showValidation">
                {{ "PAYMENT_PAGE.MODAL_RETURN.FILE_ATTENTION" | translate }} <span class="required">*</span>
              </p>
              <div
                id="files"
                class="form-frame__body-file"
                [class.error]="files.length === 0 && showValidation">
                <ngx-file-drop
                  (onFileDrop)="dropped($event)"
                  (onFileOver)="fileOver($event)"
                  (onFileLeave)="fileLeave($event)"
                  dropZoneLabel="Drop files here">
                  <ng-template
                    ngx-file-drop-content-tmp
                    let-openFileSelector="openFileSelector">
                    <button
                      (click)="openFileSelector()"
                      type="button"
                      class="download-btn">
                      <span class="download-btn__content">
                        {{ "AGREEMENT.RETURN_PAYMENT.TITLE" | translate }}
                      </span>
                      <span class="download-btn__content-description">
                        {{ "AGREEMENT.RETURN_PAYMENT.DESCRIPTION_1" | translate }}
                        <span class="accent"> {{ "AGREEMENT.RETURN_PAYMENT.DESCRIPTION_2" | translate }} </span>
                        {{ "AGREEMENT.RETURN_PAYMENT.DESCRIPTION_3" | translate }}
                        <span class="accent"> {{ "AGREEMENT.RETURN_PAYMENT.DESCRIPTION_4" | translate }} </span>
                      </span>
                    </button>
                  </ng-template>
                </ngx-file-drop>
              </div>
              <ul class="form-frame__body-attach-list">
                <li
                  *ngFor="let item of files; let i = index"
                  class="file-item">
                  {{ item.relativePath }}
                  <button
                    (click)="deleteFile(i)"
                    class="file-item__delete"></button>
                </li>
              </ul>
            </ng-container>
          </div>
        </div>
        <div class="return-payment__line-right">
          <div class="bills">
            <h3 class="headline">{{ "PAYMENT_PAGE.MODAL_RETURN.RETURNS_LIST" | translate }}: <span class="required">*</span></h3>
            <div class="bills__list" [class.error]="!selectedClaimsId.length && showValidation">
              <ul>
                <li>
                  <app-checkbox-item
                    (changeItem)="toggleAllClaims($event)"
                    [item]="allClaims">
                  </app-checkbox-item>
                </li>
                <li *ngFor="let claim of claimsList">
                  <div class="claim-info">
                    <app-checkbox-item
                      [isDisabled]="claim.isDisabled"
                      (changeItem)="toggleClaim($event)"
                      [isLocalized]="true"
                      [item]="claim">
                    </app-checkbox-item>
                    <div class="claim-info__sum">
                      <span class="claim-info__sum-count">{{ claim.sum }}</span>
                      <span class="claim-info__sum-currency">{{ "PAYMENT_PAGE.MODAL_RETURN.CURRENCY" | translate }}</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-block">
      <button
        [disabled]="isSending"
        (click)="sendFormData()"
        class="btn btn-accent">
        {{ "PAYMENT_PAGE.MODAL_RETURN.SAVE" | translate }}
      </button>
      <button
        (click)="closeModal()"
        class="btn btn-light">
        {{ "PAYMENT_PAGE.MODAL_RETURN.CANCEL" | translate }}
      </button>
    </div>
  </div>
</div>
